<div class="pane-header theme-light d-flex mb-4">
  <div class="header-back-button">
    <a
      href="#"
      class="p-4 header-background round-background container-theme-light-icons"
      (click)="back($event)"
    >
      <i class="fa fa-arrow-left m-auto"></i>
    </a>
  </div>
  <div class="header-title">
    <h1 class="font-size-header font-weight-bold">
      {{ title }}
    </h1>
  </div>
  <div class="header-actions pr-2">
    <app-profile-menu *ngIf="showMenu"/>
  </div>
</div>
